import { useDispatch } from "react-redux";
import searchIcon from "../assets/images/search.svg";
import debounce from "./../lib/debounce";
import { titleFilter } from "./../Redux/filters/actionCreator";

const SearchBar = () => {
  const dispatch = useDispatch();

  const handleChange = (e) => {
    dispatch(titleFilter(e.target.value.trim()));
  };
  return (
    <div className='border mb-8 border-slate-200 flex items-center w-11/12 lg:w-1/2 mx-auto bg-gray-50 h-12 px-5 rounded-lg text-sm ring-emerald-200'>
      <input
        className='outline-none border-none bg-gray-50 h-full w-full mr-2'
        type='search'
        name='search'
        placeholder='Search'
        defaultValue=''
        onChange={debounce(handleChange, 500)}
      />
      <img className='inline h-6 cursor-pointer' src={searchIcon} alt='Search' />
    </div>
  );
};

export default SearchBar;
